
import { computed, defineComponent, onMounted, ref, Ref } from "vue";
import POSTSection from "../interfaces/Section/POSTSection.interface";
import BackButton from "../components/BackButton.vue";
import { useRouter } from "vue-router";
import User from "../interfaces/User/User.interface";
import UserStats from "../interfaces/User/UserStats.interface";
import { store } from "../store";
export default defineComponent({
  name: "UserProfile",
  components: { BackButton },
  props: {
    id: {
      required: true,
      type: String,
    },
  },
  setup(props) {
    const router = useRouter();
    const user: Ref<User> = ref({
      userId: -1,
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      isAdmin: false,
      expirationDate: "",
    });
    const userStats: Ref<UserStats> = ref({
      totalHoursOfReservations: 0,
      totalReservations: 0,
      favouriteRoom: {
        roomCode: "",
        sections: [] as POSTSection[],
      },
      favouriteSection: {
        sectionName: "",
      },
    });

    /**
     * Retrieves the user and it's stats
     */
    onMounted(async () => {
      const response = await Promise.all([
        store.dispatch("getUser", props.id),
        store.dispatch("getUserStatistics", props.id),
      ]);
      if (response[0] !== null) {
        user.value = response[0];
      }

      if (response[1] !== null) {
        userStats.value = response[1];
      }
    });

    /**
     * Deletes the current user
     */
    const deleteUser = async () => {
      if (window.confirm("Are you sure you want do delete the user?")) {
        if (await store.dispatch("deleteUser", user.value.userId)) {
          router.push(`/users`);
        }
      }
    };

    const isAdmin = computed(() => store.getters.getUser.isAdmin);

    return {
      user,
      userStats,
      deleteUser,
      isAdmin,
    };
  },
});
